import { apiClient } from '@/services';

export const PdfService = {
  getPdfTerms() {
    return apiClient.get('/pdf/terms');
  },
};